import React from 'react';
import PropTypes from 'prop-types';

import { TableCard, ProductsTable } from 'src/components';

const DetailViewComponent = ({
  category,
  subcategory,
  isViewAllActive,
}) => (
  <TableCard
    {...{
      category: category.name,
      subcategory: subcategory.name,
      expanded: true,
    }}
  >
    <ProductsTable {...{ category, subcategory, isViewAllActive }} />
  </TableCard>
);

DetailViewComponent.propTypes = {
  category: PropTypes.object.isRequired,
  subcategory: PropTypes.object.isRequired,
  isViewAllActive: PropTypes.bool,
};

export default DetailViewComponent;
